import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Utils } from '../../utils';
import { KebabComponent } from '../../../layout/designs/kebab-component/kebab-component';

@Component({
  selector: 'app-media-card',
  standalone: true,
  imports: [CommonModule, RouterModule, KebabComponent],
  templateUrl: './media-card.component.html',
  styleUrl: './media-card.component.scss'
})
export class MediaCardComponent implements OnInit {
  @Input() data: any;
  @Input() mediaType?: 'movie' | 'tv' | 'person';
  @Input() showKebab: boolean = true;
  @Input() priority: boolean = false;

  isKebabActive = false;

  constructor(public utils: Utils) {}

  ngOnInit(): void {
    if (this.data?.media_type) {
      this.mediaType = this.data.media_type;
    }
  }

  get currentMediaType(): 'movie' | 'tv' | 'person' {
    if (this.data?.media_type === 'movie' || this.data?.media_type === 'tv' || this.data?.media_type === 'person') {
      return this.data.media_type;
    }
    if (this.data?.first_air_date || (this.data?.name && !this.data?.title)) {
      return 'tv';
    }
    if (this.data?.known_for_department || this.data?.profile_path) {
      return 'person';
    }
    if (this.mediaType) {
      return this.mediaType;
    }
    return 'movie';
  }

  get displayTitle(): string {
    return (
      this.data?.title ||
      this.data?.original_title ||
      this.data?.name ||
      this.data?.original_name ||
      'Untitled'
    );
  }

  get truncatedTitle(): string {
    const title = this.displayTitle;
    if (title.length > 28) {
      return title.slice(0, 26) + '...';
    }
    return title;
  }

  get detailRoute(): (string | number)[] {
    const type = this.currentMediaType;
    const title = this.displayTitle;
    const titleSlug = this.utils.movieNameSplitter(title) || 'details';
    const id = this.data?.id || this.data?.movie_id || this.data?._id;
    const slug = id ? `${id}-${titleSlug}` : titleSlug;
    return ['/', type, slug];
  }

  get posterUrl(): string {
    const path = this.currentMediaType === 'person' 
      ? (this.data?.profile_path || this.data?.profile_url) 
      : (this.data?.poster_path || this.data?.poster_url);
    if (!path) {
      return '/assets/images/not_found_2_3.png';
    }
    if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('/assets/')) {
      return path;
    }
    if (this.currentMediaType === 'person') {
      return `https://image.tmdb.org/t/p/w185${path}`;
    }
    return `https://image.tmdb.org/t/p/w342${path}`;
  }

  get ratingPercentage(): number {
    return this.utils.filerRatings(this.data?.vote_average ?? 0);
  }

  get hasRating(): boolean {
    return (
      this.currentMediaType !== 'person' &&
      this.data?.vote_average !== undefined &&
      this.data?.vote_average !== null &&
      this.data?.vote_average > 0
    );
  }

  get displayMeta(): string {
    if (this.currentMediaType === 'person') {
      if (this.data?.character) {
        return `as ${this.data.character}`;
      }
      return this.data?.known_for_department || 'Celebrity';
    }
    const date = this.data?.release_date || this.data?.first_air_date;
    if (this.data?.character) {
      const year = date ? String(date).slice(0, 4) : '';
      return year ? `${year} • as ${this.data.character}` : `as ${this.data.character}`;
    }
    return date || '';
  }

  onKebabToggle(isActive: boolean): void {
    this.isKebabActive = isActive;
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/images/not_found_2_3.png';
  }
}
